export default {
	TABLE_TITLE: 'Addon ingredient',
	ADDON_INGREDIENT_ADDED: 'Addon ingredient added.',
	ADDON_INGREDIENT_EDITED: 'Addon ingredient edited.',
	ADDON_INGREDIENTS_EDITED: 'Addon ingredients edited.',
	ADDON_INGREDIENT_DELETED: 'Addon ingredient deleted.'
};
